import React from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as PlayIcon } from '../../svg/play.svg';

const SvgButtonWrapper = styled('button')`
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;

  svg {
    width: 1em;
    height: 1em;

    path {
      fill: white;
    }
  }
`;

const PlayButton = ({ onClick, className }) => (
  <SvgButtonWrapper
    onClick={onClick}
    className={className}
    aria-label="Play video"
  >
    <PlayIcon />
  </SvgButtonWrapper>
);

export default PlayButton;
